import React from "react";
import { Card, Col, Form } from "react-bootstrap";
import Swal from "sweetalert2";
import { MutantApiService } from "../../../../services/MutantApiService";
import IsValidName from "../../../../utils/validators/IsValidName";
import Loading from "../../../home/components/Loading";
import { StyledCardBody } from "../../components/AdminCard/style";
import { AdminTitle } from "../../components/AdminTitle";
import FormActions from "../../components/FormActions";
import { InputField } from "../../components/InputField";
import Roles from "../../../../enums/RoleEnum";

import store from "../../../../store/store";

const roleOptions = [
  { value: Roles.ADMIN, label: Roles.ADMIN },
  { value: Roles.USER, label: Roles.USER },
  { value: Roles.MANAGER, label: Roles.MANAGER },
];
const initialState = {};

export default class UsersForm extends React.Component {
  constructor(props) {
    super(props);

    const { auth } = store.getState();
    this.state = {
      id: 0,
      name: "",
      role: "",
      isLoading: false,
      isEditing: false,
      userLogged: auth.user,
      isEdit: false,
      apiUser: {},
    };

    this.api = new MutantApiService();

    this.handleChange = this.handleChange.bind(this);
    this.onCleanForm = this.onCleanForm.bind(this);
    this.submit = this.submit.bind(this);
    this.handleRoleChange = this.handleRoleChange.bind(this);
  }

  async componentDidMount() {
    const isEditing = !!this.props.match.params.id;
    this.setState({ isLoading: true, isEditing });
    try {
      if (this.props.match.params.id) {
        await this.loadUser(this.props.match.params.id);
      }
    } catch (error) {
      await Swal.fire(
        "Erro!",
        "Ocorreu um erro ao carregar os dados, tente novamente mais tarde!",
        "error"
      );
    }

    this.setState({ isLoading: false });
  }

  loadUser = async (id) => {
    const user = await this.api.makeHttpRequest({
      url: `/user/${id}`,
    });
    this.setState({
      id: id,
      name: `${user.firstName} ${user.lastName}`,
      role: { value: user.role, label: user.role },
      isLoading: false,
      isEdit: true,
      apiUser: user,
    });
  };

  submit = async (e) => {
    e.preventDefault();

    const id = this.props.match.params.id;
    this.setState({ isLoading: true });
    try {
      const reqBase = id
        ? { method: "PATCH", url: `/user/${id}` }
        : { method: "POST", url: "/user" };

      await this.api.makeHttpRequest({
        ...reqBase,
        data: {
          ...this.state.apiUser,
          role: this.state.role.value,
        },
      });

      this.afterSubmit();
    } catch (e) {
      Swal.fire(
        "Erro!",
        e?.response?.data
          ? e.response.data.message
          : "Erro ao cadastrar cliente, tente novamente mais tarde.",
        "error"
      );
    }

    this.setState({ isLoading: false });
  };

  afterSubmit = async () => {
    this.setState({
      ...initialState,
      resetInput: true,
    });

    const { isEditing } = this.state;

    const { value } = await Swal.fire({
      title: "Sucesso!",
      text: "Dados salvos com sucesso.",
      icon: "success",
      showCancelButton: !isEditing,
      confirmButtonText: isEditing ? "Ok" : "Novo cadastro",
      cancelButtonText: "Sair",
    });
		if(value){
			this.state = {
				...initialState,
				resetInput: true,
			}
		}
    if (!value || isEditing) {
      this.props.history.push("/dashboard/users");
    }
  };

  handleChange = (e) => {
    this.setState({
      [e.target.firstName]: e.target.value,
    });
  };

  handleRoleChange = (e) => {
    let value = e?.value ? e?.value : "";

    this.setState({
      role: { value: value, label: value },
    });
  };

  formIsValid = () => {
    return this.state.role && this.state.role.value;
  };

  onCleanForm = async () => {
    if (this.props.match.params.id) {
      this.setState({ isLoading: true });

      try {
        await this.loadUser(this.props.match.params.id);
      } catch (e) {
        await Swal.fire(
          "Erro",
          "Problema ao reverter as alterações, tente mais tarde",
          "error"
        );
      }

      this.setState({ isLoading: false });
    } else {
      this.setState({
        ...initialState,
        resetInput: true,
      });
    }
  };

  render() {
    if (this.state.isEditing) {
      window.setPageTitle("Atualizar Usuário - Admin");
    } else {
      window.setPageTitle("Cadastro de Usuário - Admin");
    }

    const { name, role, isLoading, isEditing } = this.state;

    return (
      <>
        <Loading isLoading={isLoading} />
        <AdminTitle title="Dados do Usuário" disableHeader />
        <Card className="mt-4">
          <StyledCardBody>
            <Form style={{ flex: "1" }}>
              {/* row 1 */}
              <Form.Row>
                {/* Nome */}
                <Form.Group as={Col} lg="12" xs="12">
                  <InputField
                    type="text"
                    name="name"
                    label="Nome"
                    placeholder="Digite o nome"
                    value={name}
                    onChange={this.handleChange}
                    isInvalid={name && !IsValidName(name)}
                    disabled={true}
                  />
                </Form.Group>
              </Form.Row>
              <Form.Row>
                {/* Descrição */}
                <Form.Group as={Col} lg="6" xs="12">
                  <InputField
                    type="text"
                    as="select2"
                    name="perfil"
                    id="perfil"
                    label="Perfil"
                    placeholder="Selecione o perfil"
                    value={role}
                    onChange={this.handleRoleChange}
                    required
                    options={roleOptions}
                  />
                </Form.Group>
              </Form.Row>
            </Form>
          </StyledCardBody>
        </Card>
        <FormActions
          module="users"
          isEdit={isEditing}
          formIsValid={this.formIsValid()}
          onCleanForm={this.onCleanForm}
          onSubmit={this.submit}
          hideReload
        />
      </>
    );
  }
}
